var React = require('react');

function Database (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M24,33C13,33,4,30.8,4,28V21.8a1.05018,1.05018,0,0,1,.5-.9.90151.90151,0,0,1,.5-.1.74936.74936,0,0,1,.5.1C8.6,22.8,15.8,24,24,24s15.4-1.2,18.5-3.1a1.3,1.3,0,0,1,1,0,1.05019,1.05019,0,0,1,.5.9V28C44,30.8,35,33,24,33Z","key":0}),React.createElement("path",{"d":"M24,44C13,44,4,41.8,4,39V32.8a1.05018,1.05018,0,0,1,.5-.9.90151.90151,0,0,1,.5-.1.74936.74936,0,0,1,.5.1C8.6,33.8,15.8,35,24,35s15.4-1.2,18.5-3.1a1.3,1.3,0,0,1,1,0,1.05019,1.05019,0,0,1,.5.9V39C44,41.8,35,44,24,44Z","key":1}),React.createElement("path",{"d":"M24,22C13,22,4,19.8,4,17V9c0-2.8,9-5,20-5S44,6.2,44,9v8C44,19.8,35,22,24,22Z","key":2})]);
}

Database.displayName = "Database";

Database.defaultProps = {"viewBox":"0 0 48 48"};

module.exports = Database;

Database.default = Database;



// WEBPACK FOOTER //
// ./node_modules/pui-css-iconography/svgs/database.svg